import { useEffect, useRef } from "react";

const useSoundPlayer = (volume = 0.1) => {
  const audioContextRef = useRef(null);
  const gainNodeRef = useRef(null);
  const bufferMapRef = useRef({}); // store multiple sounds

  useEffect(() => {
    const AudioCtx = window.AudioContext || window.webkitAudioContext;

    if (AudioCtx) {
      audioContextRef.current = new AudioCtx();

      gainNodeRef.current = audioContextRef.current.createGain();
      gainNodeRef.current.gain.value = volume;

      gainNodeRef.current.connect(audioContextRef.current.destination);
    }
  }, [volume]);

  // 🔊 load sound
  const loadSound = async (key, url) => {
    
    if (!audioContextRef.current) return;
// console.log(key, "keykey 022")
    const res = await fetch(url);
    const arrayBuffer = await res.arrayBuffer();
    const buffer = await audioContextRef.current.decodeAudioData(arrayBuffer);
console.log(key, "keykey 022", buffer)
    bufferMapRef.current[key] = buffer;
  };

  // ▶️ play sound
  const playSound = (key) => {
    
    const ctx = audioContextRef.current;
    const buffer = bufferMapRef.current[key];
console.log(key, "keykey", buffer)
    if (!ctx || !buffer) return;

    if (ctx.state === "suspended") {
      ctx.resume();
    }

    const source = ctx.createBufferSource();
    source.buffer = buffer;

    gainNodeRef.current.gain.value = volume;

    source.connect(gainNodeRef.current);
    source.start(0);
  };

  return { loadSound, playSound };
};

export default useSoundPlayer;